import { Vector3 } from "three";

const moundLocation = new Vector3(0, 0, -59);
const moundHeight = 1;
const moundRadiusSq = 10 ** 2;

const groundY = 0.2;

const queryVector = new Vector3();

/**
 * Height map - takes x, z and returns height (y) - gives approx mound geometry
 * without the need to raycast
 * @param x
 * @param z
 * @returns
 */
export function groundLevel(x: number, z: number) {
  queryVector.setX(x).setZ(z);

  const distSq = queryVector.distanceToSquared(moundLocation);

  // draws sphere around mound, but only down to groundHeight
  return Math.max(groundY, moundHeight - distSq / moundRadiusSq);
}
